var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAirtable = function SvgAirtable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airtable_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.158.264 1.842 4.12a.624.624 0 0 0 .008 1.157l9.356 3.71a3.47 3.47 0 0 0 2.559 0l9.355-3.71a.624.624 0 0 0 .009-1.157L13.813.264a3.471 3.471 0 0 0-2.655 0",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.315 11.014v9.269c0 .44.445.743.854.58l10.425-4.047a.624.624 0 0 0 .394-.58v-9.27a.624.624 0 0 0-.854-.58l-10.425 4.047a.624.624 0 0 0-.394.58",
    fill: "#26B5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.881 11.492-3.094 1.494-.314.152-6.53 3.13c-.415.2-.943-.102-.943-.562v-8.7c0-.167.085-.31.2-.42a.71.71 0 0 1 .158-.118.665.665 0 0 1 .568-.043l9.903 3.924c.503.2.543.905.052 1.143",
    fill: "#ED3049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.881 11.492-3.094 1.494L.2 6.587a.71.71 0 0 1 .158-.119.665.665 0 0 1 .568-.043l9.903 3.924c.503.2.543.905.052 1.143",
    fill: "#000",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airtable_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v21H0z"
  })))));
};

export default SvgAirtable;